import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { Footer } from "./footer";
import DiscountCodeModal from "./gift-modal/DiscountCodeModal";
import GiftModal from "./gift-modal/GiftModal";
import { HeroSection, HeroSection2 } from "./hero";
import { InfoSection } from "./info";
import { LoginModal } from "./Login";
import { Seasons } from "./seasons";
import { UserComments } from "./user-comments";

const HomePage = () => {
  const { isAuthenticated } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isGiftModal, setIsGiftModal] = useState(false);
  const [isDiscountCodeModal, setIsDisCountCodeModal] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/mini-course/6", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const onOpen = () => {
    setIsModalOpen(true);
  };

  const onClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="relative">
      <HeroSection onOpen={onOpen} />
      <HeroSection2 />
      <div
        className="flex flex-col items-center justify-between overflow-hidden pb-10 pt-16"
        style={{ background: "linear-gradient(to left, #57C5F9, #A36AFF)" }}
      >
        <Seasons />
      </div>
      <div className="container mx-auto my-12">
        <UserComments />
      </div>
      <div>
        <InfoSection />
      </div>
      <Footer />
      {!isAuthenticated && (
        <div
          onClick={onOpen}
          className="fixed z-20 pb-[env(safe-area-inset-bottom)] bottom-0 w-full left-0 right-0 h-[57px] rounded-t-3xl xl:hidden bg-black flex items-center justify-center cursor-pointer gap-4 hover:cursor-pointer"
        >
          <p className="text-white font-bold font-kalameh">
            ثبت نام رایگان و شروع
          </p>

          <div className="relative w-6 h-6 flex items-center justify-center">
            <div className="absolute w-full h-full rounded-full bg-white opacity-30 blur-sm"></div>

            <img
              src="/images/arrow_right.png"
              alt="arrow_right"
              className="relative z-10"
              width={23}
              height={23}
            />
          </div>
        </div>
      )}
      {isModalOpen && <LoginModal onClose={onClose} />}
      {isGiftModal && <GiftModal onClose={() => setIsGiftModal(false)} />}
      {isDiscountCodeModal && (
        <DiscountCodeModal onClose={() => setIsDisCountCodeModal(false)} />
      )}
    </div>
  );
};

export default HomePage;
